export default {
    props: {
        axisDefaultsBackground: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.background'
        }, 
        axisDefaultsColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.color'
        }, 
        axisDefaultsCrosshairColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.color'
        }, 
        axisDefaultsCrosshairDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.dashType'
        }, 
        axisDefaultsCrosshairOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.opacity'
        }, 
        axisDefaultsCrosshairTooltipBackground: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.background'
        }, 
        axisDefaultsCrosshairTooltipBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.border.color'
        }, 
        axisDefaultsCrosshairTooltipBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.border.dashType'
        }, 
        axisDefaultsCrosshairTooltipBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.border.width'
        }, 
        axisDefaultsCrosshairTooltipColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.color'
        }, 
        axisDefaultsCrosshairTooltipFont: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.font'
        }, 
        axisDefaultsCrosshairTooltipFormat: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.format'
        }, 
        axisDefaultsCrosshairTooltipPadding: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding'
        }, 
        axisDefaultsCrosshairTooltipPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.bottom'
        }, 
        axisDefaultsCrosshairTooltipPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.left'
        }, 
        axisDefaultsCrosshairTooltipPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.right'
        }, 
        axisDefaultsCrosshairTooltipPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.padding.top'
        }, 
        axisDefaultsCrosshairTooltipTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.template'
        }, 
        axisDefaultsCrosshairTooltipVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.tooltip.visible'
        }, 
        axisDefaultsCrosshairVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.visible'
        }, 
        axisDefaultsCrosshairWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.crosshair.width'
        }, 
        axisDefaultsLabelsFont: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.labels.font'
        }, 
        axisDefaultsLabelsFormat: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.labels.format'
        }, 
        axisDefaultsLabelsMargin: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin'
        }, 
        axisDefaultsLabelsMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.bottom'
        }, 
        axisDefaultsLabelsMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.left'
        }, 
        axisDefaultsLabelsMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.right'
        }, 
        axisDefaultsLabelsMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.margin.top'
        }, 
        axisDefaultsLabelsMirror: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.labels.mirror'
        }, 
        axisDefaultsLabelsPadding: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding'
        }, 
        axisDefaultsLabelsPaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.bottom'
        }, 
        axisDefaultsLabelsPaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.left'
        }, 
        axisDefaultsLabelsPaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.right'
        }, 
        axisDefaultsLabelsPaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.padding.top'
        }, 
        axisDefaultsLabelsRotation: {
            type: [Number, String],
            default: undefined,
            kComposite: 'axisDefaults.labels.rotation'
        }, 
        axisDefaultsLabelsRotationAlign: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.labels.rotation.align'
        }, 
        axisDefaultsLabelsRotationAngle: {
            type: [Number, String],
            default: undefined,
            kComposite: 'axisDefaults.labels.rotation.angle'
        }, 
        axisDefaultsLabelsSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.skip'
        }, 
        axisDefaultsLabelsStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.labels.step'
        }, 
        axisDefaultsLabelsTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'axisDefaults.labels.template'
        }, 
        axisDefaultsLabelsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.labels.visible'
        }, 
        axisDefaultsLabelsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'axisDefaults.labels.visual'
        }, 
        axisDefaultsLineColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.line.color'
        }, 
        axisDefaultsLineDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.line.dashType'
        }, 
        axisDefaultsLineVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.line.visible'
        }, 
        axisDefaultsLineWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.line.width'
        }, 
        axisDefaultsMajorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.color'
        }, 
        axisDefaultsMajorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.dashType'
        }, 
        axisDefaultsMajorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.visible'
        }, 
        axisDefaultsMajorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.width'
        }, 
        axisDefaultsMajorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.step'
        }, 
        axisDefaultsMajorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorGridLines.skip'
        }, 
        axisDefaultsMajorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.color'
        }, 
        axisDefaultsMajorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.size'
        }, 
        axisDefaultsMajorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.visible'
        }, 
        axisDefaultsMajorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.width'
        }, 
        axisDefaultsMajorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.step'
        }, 
        axisDefaultsMajorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.majorTicks.skip'
        }, 
        axisDefaultsMinorGridLinesColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.color'
        }, 
        axisDefaultsMinorGridLinesDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.dashType'
        }, 
        axisDefaultsMinorGridLinesVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.visible'
        }, 
        axisDefaultsMinorGridLinesWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.width'
        }, 
        axisDefaultsMinorGridLinesStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.step'
        }, 
        axisDefaultsMinorGridLinesSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorGridLines.skip'
        }, 
        axisDefaultsMinorTicksColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.color'
        }, 
        axisDefaultsMinorTicksSize: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.size'
        }, 
        axisDefaultsMinorTicksVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.visible'
        }, 
        axisDefaultsMinorTicksWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.width'
        }, 
        axisDefaultsMinorTicksStep: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.step'
        }, 
        axisDefaultsMinorTicksSkip: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.minorTicks.skip'
        }, 
        axisDefaultsNarrowRange: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.narrowRange'
        }, 
        axisDefaultsPane: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.pane'
        }, 
        axisDefaultsPlotBands: {
            type: Array,
            default: undefined,
            kComposite: 'axisDefaults.plotBands'
        },         axisDefaultsReverse: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.reverse'
        }, 
        axisDefaultsStartAngle: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.startAngle'
        }, 
        axisDefaultsTitleBackground: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.background'
        }, 
        axisDefaultsTitleBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.border.color'
        }, 
        axisDefaultsTitleBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.border.dashType'
        }, 
        axisDefaultsTitleBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.border.width'
        }, 
        axisDefaultsTitleColor: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.color'
        }, 
        axisDefaultsTitleFont: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.font'
        }, 
        axisDefaultsTitleMargin: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin'
        }, 
        axisDefaultsTitleMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.bottom'
        }, 
        axisDefaultsTitleMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.left'
        }, 
        axisDefaultsTitleMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.right'
        }, 
        axisDefaultsTitleMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.margin.top'
        }, 
        axisDefaultsTitlePadding: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding'
        }, 
        axisDefaultsTitlePaddingBottom: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.bottom'
        }, 
        axisDefaultsTitlePaddingLeft: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.left'
        }, 
        axisDefaultsTitlePaddingRight: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.right'
        }, 
        axisDefaultsTitlePaddingTop: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.padding.top'
        }, 
        axisDefaultsTitlePosition: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.position'
        }, 
        axisDefaultsTitleRotation: {
            type: Number,
            default: undefined,
            kComposite: 'axisDefaults.title.rotation'
        }, 
        axisDefaultsTitleText: {
            type: String,
            default: undefined,
            kComposite: 'axisDefaults.title.text'
        }, 
        axisDefaultsTitleVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.title.visible'
        }, 
        axisDefaultsTitleVisual: {
            type: Function,
            default: undefined,
            kComposite: 'axisDefaults.title.visual'
        }, 
        axisDefaultsVisible: {
            type: Boolean,
            default: undefined,
            kComposite: 'axisDefaults.visible'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartBase/AxisDefaults.js